<template>
  <div class="viewproject-step2">
    <h3 class="page-title mb-8 mt-1">Анализ от AI-эксперта</h3>

    <ProjectStep4 hideControls class="mt-4 mb-4"/>

    <div class="profile-item-title">Комментарий</div>
    <div class="profile-item-value">
      <v-textarea :value="comment" outlined dense no-resize hide-details readonly rows="15" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from 'vuex';
import ProjectStep4 from './ProjectStep4.vue';

export default {
  name: 'AIPage',
  components: {
    ProjectStep4
  },
  props:{
  },
  data() {
    return {
      comment: `Команда сбалансирована и покрывает ключевые направления проекта. Сильный технический состав (разработчики), что критично для IT-продукта. \r
        Рекомендации по донабору:
        Тестировщик (QA) — для усиления контроля качества перед релизом MVP.
        Методист/Educational Designer — если платформа будет создавать собственные курсы (а не только агрегировать сторонние).
        Аналитик данных — для глубокой обработки метрик обучения и персонализации рекомендаций.`
    };
  },
  computed: {
    ...mapGetters({
      curProject: 'ai/hrprojects/curProject',
      loading: 'ai/hrprojects/loading',
    }),
  },
  methods: {
    ...mapActions({
      findCandidates: 'ai/hrprojects/findCandidates',
    }),
  },
  mounted() {
    this.findCandidates(this.curProject);
  },
};
</script>

<style lang="scss" scoped>

.viewproject-step2 {
  width: 1200px;
  max-width: 100%;
}

.project-range {
  width: 300px; 
  max-width: 100%;

}
</style>

